import React from "react";
import "./ResultContainer.css";
import dogDictionary from "../db/dogDatabase";

function ResultContainer({ closestDog }) {
  // let closestDog = result.reduce((prev, current) =>
  //   prev.confidence > current.confidence ? prev : current
  // );

  // useEffect(() => {
  //   updateDogImage("/dogImages/" + dogDictionary[closestDog.label].imageUrl);
  // }, []);

  return (
    <div className="resultContainer">
      <div className="result-answer">당신은 {closestDog.label}상 입니다.</div>

      <div className="result-description">
        {dogDictionary[closestDog.label].description}
      </div>
    </div>
  );
}

export default ResultContainer;
